import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartComponent } from './cart/cart.component';
import { ModalsComponent } from './modals/modals.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    CartComponent,
    ModalsComponent
  ],
  imports: [
    CommonModule, NgxSpinnerModule.forRoot()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CartComponent,
    NgxSpinnerModule
  ]
})
export class SharedModule { }
